"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$ = exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$outboundSchema = exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$inboundSchema = exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$ = exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$outboundSchema = exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$inboundSchema = void 0;
exports.getPostcodeAddressesPostcodesPostcodePropertiesGetSecurityToJSON = getPostcodeAddressesPostcodesPostcodePropertiesGetSecurityToJSON;
exports.getPostcodeAddressesPostcodesPostcodePropertiesGetSecurityFromJSON = getPostcodeAddressesPostcodesPostcodePropertiesGetSecurityFromJSON;
exports.getPostcodeAddressesPostcodesPostcodePropertiesGetRequestToJSON = getPostcodeAddressesPostcodesPostcodePropertiesGetRequestToJSON;
exports.getPostcodeAddressesPostcodesPostcodePropertiesGetRequestFromJSON = getPostcodeAddressesPostcodesPostcodePropertiesGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$;
(function (GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$) {
    /** @deprecated use `GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$inboundSchema` instead. */
    GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$.inboundSchema = exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$inboundSchema;
    /** @deprecated use `GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$outboundSchema` instead. */
    GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$.outboundSchema = exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$outboundSchema;
})(GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$ || (exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$ = GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$ = {}));
function getPostcodeAddressesPostcodesPostcodePropertiesGetSecurityToJSON(getPostcodeAddressesPostcodesPostcodePropertiesGetSecurity) {
    return JSON.stringify(exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$outboundSchema
        .parse(getPostcodeAddressesPostcodesPostcodePropertiesGetSecurity));
}
function getPostcodeAddressesPostcodesPostcodePropertiesGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPostcodeAddressesPostcodesPostcodePropertiesGetSecurity' from JSON`);
}
/** @internal */
exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$inboundSchema = z.object({
    postcode: z.string(),
});
/** @internal */
exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$outboundSchema = z.object({
    postcode: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$;
(function (GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$) {
    /** @deprecated use `GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$inboundSchema` instead. */
    GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$.inboundSchema = exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$inboundSchema;
    /** @deprecated use `GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$outboundSchema` instead. */
    GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$.outboundSchema = exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$outboundSchema;
})(GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$ || (exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$ = GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$ = {}));
function getPostcodeAddressesPostcodesPostcodePropertiesGetRequestToJSON(getPostcodeAddressesPostcodesPostcodePropertiesGetRequest) {
    return JSON.stringify(exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$outboundSchema
        .parse(getPostcodeAddressesPostcodesPostcodePropertiesGetRequest));
}
function getPostcodeAddressesPostcodesPostcodePropertiesGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPostcodeAddressesPostcodesPostcodePropertiesGetRequest' from JSON`);
}
//# sourceMappingURL=getpostcodeaddressespostcodespostcodepropertiesget.js.map